import React from "react";
import { useAppSelector } from "../store/hooks";

// Constants - Using CSS Variables
const COLORS = {
  primary: "var(--primary)",
  textPrimary: "var(--text-primary)",
  textSecondary: "var(--text-tertiary)",
  border: "var(--border-primary)",
} as const;

interface TopBarProps {
  onMobileMenuToggle: () => void;
  sidebarWidth: string;
  isCollapsed: boolean;
}

const TopBar: React.FC<TopBarProps> = ({
  onMobileMenuToggle,
  sidebarWidth,
  isCollapsed,
}) => {
  const { user } = useAppSelector((state) => state.auth);

    return (
        <header 
            className="bg-white border-b border-gray-200 sticky top-0 z-30"
            role="banner"
        >
      <div className="px-4 py-4 desktop-padding">
        <div className="flex items-center justify-between">
          {/* Left Section */}
          <div className="flex items-center">
            {/* Mobile Menu Button */}
            <button
              onClick={onMobileMenuToggle}
              className="mobile-menu-btn p-2 rounded-lg hover:bg-gray-100 transition-colors"
              aria-label="Toggle mobile menu"
            >
              <svg
                className="w-6 h-6 text-gray-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
            </button>

            {/* Desktop Logo - Only show when sidebar is collapsed */}
            {isCollapsed && (
              <div className="hidden desktop-only items-center ml-4">
                <img
                  src="/assets/logo-circle.png"
                  alt="Penny Appeal GMS Logo"
                  className="w-8 h-8"
                  width={32}
                  height={32}
                />
                <span className="ml-2 text-lg font-semibold" style={{ color: COLORS.textPrimary }}>
                  Penny Appeal
                </span>
              </div>
            )}
          </div>

          {/* Right Section */}
          <div className="flex items-center space-x-4">
            {/* User Profile */}
            <div className="flex items-center space-x-3">
              <div
                className="h-8 w-8 flex items-center justify-center border rounded-full"
                style={{
                  backgroundColor: "var(--bg-primary)",
                  borderColor: "var(--border-primary)",
                }}
              >
                <svg
                  className="w-4 h-4 text-gray-600"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  aria-hidden="true"
                >
                  <path
                    fillRule="evenodd"
                    d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
              <div className="hidden sm:block text-left">
                <div
                  className="text-sm font-semibold"
                  style={{ color: COLORS.textPrimary }}
                >
                  {user?.email || 'User'}
                </div>
                <div
                  className="text-xs"
                  style={{ color: COLORS.textSecondary }}
                >
                  {user?.role || 'Admin'}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default TopBar;
